import installationInstructions from './installationInstructions';

const p161Content = {
  installationInstructions
}

export { p161Content };
